import React from 'react';
import { Link } from 'react-router-dom';
import './InternalFooter.css';

const InternalFooter = () => {
  return (
    <footer className="internal-footer-section">
      <div className="internal-container">
        <div className="internal-footer-bottom">
          <p>© {new Date().getFullYear()} <Link className='home-link' to="/">flowdo</Link>. All rights reserved.</p>
        </div>
      </div>
    </footer>
  );
};

export default InternalFooter;